import styled from '@emotion/styled'
import { Button, Dropdown, Input, Segment, Table } from 'semantic-ui-react'

export const SearchOptionStyle = styled.div`
  &&&& {
    padding-left: 16px;
    padding-top: 4px;
  }
`

export const SearchLimitStyle = styled.div`
  &&&& {
    padding-left: 16px;

    select {
      margin-top: -2px;
    }

    @-moz-document url-prefix() {
      select {
        padding: 2px 5px;
      }
    }
  }
`

export const CustomAliasInput = styled(Input)`
  &&&&& {
    flex-grow: 1;
    input {
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 0;
      padding-right: 0;
      border-radius: 0;
      border-top: none;
      border-left: none;
      border-right: none;
      background: none;

      ::placeholder {
        color: #666;
        opacity: 1;
      }
    }
    button {
      box-shadow: none !important;
    }
  }
`

export const CustomBatchListTable = styled(Table)`
  &&&&& {
    table-layout: fixed;
    width: 100%;

    tr {
      cursor: pointer;

      td.icon-cell {
        width: 24px;
        padding-left: 10px;
      }

      td.name-cell {
        word-wrap: break-word;
        padding-left: 6px;
        padding-right: 6px;
      }
    }

    tr.active {
      td.positive {
        background: #f7ffe6 !important;
      }
    }
  }
`

export const BatchIgnoreBtn = styled(Button)`
  &&&& {
    box-shadow: none;
    vertical-align: middle;
    margin-left: 5px;
    margin-bottom: 0;
    padding: 2px 5px;

    &:active,
    &:focus {
      color: rgba(0, 0, 0, 0.6) !important;
      background: none !important;
    }
  }
`

export const CustomSegment = styled(Segment)([
  {
    paddingTop: '13px !important',
  },
])

export const CustomCopyButton = styled(Button)([
  {
    padding: '0.5rem !important',
  },
])

export const CustomInput = styled(Input)`
  &&.disabled {
    opacity: 1;
  }
`

export const CustomDropdown = styled(Dropdown)`
  && {
    width: 4em;
    padding: 0.3em 1em;
  }
`
